// extracted by mini-css-extract-plugin
export var growableInput = "_9x-0";
export var tagContainer = "_9x-2";
export var textInput = "_9x-1";